var _linearGradient, _linearGradient2, _linearGradient3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageTitleBgMobile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    height: 178,
    viewBox: "0 0 375 178",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "rhkddecd6b",
    x1: 0.974,
    y1: 0.055,
    x2: 0.064,
    y2: 0.968,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dedede"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lnjdcayifd",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fadc3a"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "mma3wjdobe",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeb5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#ffec74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd0"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "h1yqxxg5ka"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5671",
    transform: "translate(0 60)",
    style: {
      fill: "#fff",
      stroke: "#707070"
    },
    d: "M0 0h375v178H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0dc119hz9c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 263",
    transform: "translate(-.293 -.11)",
    style: {
      fill: "#fff",
      stroke: "#707070"
    },
    d: "M0 0h670v200H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 459",
    transform: "translate(0 -60)",
    style: {
      clipPath: "url(#h1yqxxg5ka)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2070"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 245",
    transform: "translate(-248 40)",
    style: {
      fill: "url(#rhkddecd6b)"
    },
    d: "M0 0h842v198H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 7",
    transform: "translate(-108.707 38.11)",
    style: {
      clipPath: "url(#0dc119hz9c)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3271",
    d: "M89.3 0a89.3 89.3 0 0 1 89.3 89.3v161.9a89.3 89.3 0 0 1-178.6 0V89.3A89.3 89.3 0 0 1 89.3 0z",
    transform: "rotate(-55 167.68 40.458)",
    style: {
      opacity: 0.398,
      fill: "url(#lnjdcayifd)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 157",
    d: "M178.6 0v244.88A178.6 178.6 0 0 1 0 423.476V178.6A178.6 178.6 0 0 1 178.6 0z",
    transform: "rotate(-146 218.256 130.64)",
    style: {
      fill: "url(#mma3wjdobe)"
    }
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageTitleBgMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/image-titleBgMobile.b2cb4de524534bf56278182239b13715.svg";